"use strict";

exports.__esModule = true;
exports.ConditionLevels = void 0;
var ConditionLevels = exports.ConditionLevels = [{
  value: "Fault",
  displayName: "Fault"
}, {
  value: "Warning",
  displayName: "Warning"
}];